import React from 'react';
import { Helmet } from 'react-helmet';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import VideoBlock from '../../../components/molecules/videoBlock';

const VideoBlockTastic = ({ data, isServerSideRendering, context }) => {
  const isSSR = typeof isServerSideRendering === 'boolean' && isServerSideRendering;
  if (!data || isSSR) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

    return (
      <>
        <Helmet>
          <link href="https://unpkg.com/cloudinary-video-player@1.9.5/dist/cld-video-player.min.css" rel="stylesheet"/>
          <script src="https://unpkg.com/cloudinary-video-player@1.9.5/dist/cld-video-player.min.js" type="text/javascript"/>
        </Helmet>
        <VideoBlock {...data} />
      </>
    );
};

export default tastify({
  translate: true,
  connect: {
    isServerSideRendering: true,
    context: true,
  }
})(VideoBlockTastic);
